import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { parseAmount, friendlyCreditCardMask } from 'app/utils/parsers';
import { renderAssemblyJs } from 'app/utils/assembly';

// import history from 'app/routes/history';
import { changeState } from '@teammo/teammo-general-utils';
import Isvg from 'react-inlinesvg';

import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import { Label, Collapse, Tooltip } from 'reactstrap';
import Loader from 'app/components/general/Loader';
import SectionGroup from 'app/components/general/SectionGroup';
import PaymentCardMin from 'app/components/matches/PaymentCardMin';
import CreditCardInput from 'app/components/general/CreditCardInput';
import CreditCardInputNew from 'app/components/general/CreditCardInputNew';
import Checkbox from 'app/components/general/Checkbox';
import HelpTooltip from 'app/components/general/HelpTooltip';
import PaymentProcessingLoader from 'app/components/teamPaymentRequests/PaymentProcessingLoader';

import MastercardIcon from 'app/images/icons/credit-card-mastercard.svg';
import VisaIcon from 'app/images/icons/credit-card-visa.svg';
import LockIcon from 'app/images/icons/lock.svg';
import CartSummary from '../CartSummary';

export interface ICheckoutLineItem {
  amount: number;
  description: string;
  quantity: number;
}

interface ICheckoutComponentProps {
  matchCardData: {
    round: string;
    dateTime: string;
    eventInfo: string;
    amount: string;
    section: string;
    time: string;
    location: string;
    status: string;
    otherTeamStatus: string;
    statuses: [
      {
        colour: string;
        text: string;
      }
    ];
  };
  bulkMatchPaymentId: string;
  matchPaymentId: string;
  totalAmount: number;
  isLoading: boolean;
  cardIsLoading: boolean;
  saveCardAllowed: boolean;
  accepted: boolean;
  creditCardToken: string;
  creditCardUserId: string;
  description: string;
  cardName: string;
  cardNumber: string;
  cardExpiry: string;
  cardCvv: string;
  paymentCategory: string;
  existingCard: boolean;
  existingCardMaskedNumber: string;
  existingCardExpiry: string;
  handleSubmit: any;
  backendErrors: any;
  processingBackendErrors: any;
  lineItems: any;
  errors: any;
  secureReference: string;
  currentPurchaseStatus: string;
  createCreditCardToken: Function;
}

export interface ICheckoutState {
  cardName: string;
  cardNumber: string;
  cardExpiry: string;
  cardCvv: string;
  errors: {
    cardName?: string;
    cardNumber?: string;
    cardExpiry?: string;
    cardCvv?: string;
  };
  saveCardAllowed: boolean;
  accepted: boolean;
  backendErrors: any;
  processingBackendErrors: any;
  isLoading: boolean;
  cardSecurityTooltip: boolean;
  changed: boolean;
  newCard: boolean;
  existingCard: boolean;
  existingCardMaskedNumber: string;
  existingCardExpiry: string;
  creditCardFormReady: boolean;
  providerProcessing: boolean;
  createCardError: boolean;
}

export default class CheckoutComponent extends React.Component<
  ICheckoutComponentProps,
  ICheckoutState
> {
  static defaultProps: ICheckoutComponentProps = {
    matchCardData: {
      round: undefined,
      dateTime: undefined,
      eventInfo: undefined,
      amount: undefined,
      section: undefined,
      time: undefined,
      location: undefined,
      statuses: undefined,
      status: undefined,
      otherTeamStatus: undefined,
    },
    matchPaymentId: undefined,
    paymentCategory: undefined,
    description: undefined,
    totalAmount: undefined,
    isLoading: false,
    saveCardAllowed: undefined,
    accepted: undefined,
    cardName: undefined,
    cardNumber: undefined,
    cardExpiry: undefined,
    cardCvv: undefined,
    existingCard: false,
    existingCardMaskedNumber: undefined,
    existingCardExpiry: undefined,
    handleSubmit: undefined,
    backendErrors: {},
    processingBackendErrors: {},
    currentPurchaseStatus: undefined,
    lineItems: {},
    errors: undefined,
    secureReference: undefined,
    creditCardUserId: undefined,
    creditCardToken: undefined,
  };

  state = {
    cardName: '',
    cardNumber: '',
    cardCvv: '',
    cardExpiry: '',
    errors: {
      cardName: undefined,
      cardNumber: undefined,
      cardExpiry: undefined,
      cardCvv: undefined,
    },
    backendErrors: {},
    processingBackendErrors: {},
    saveCardAllowed: false,
    accepted: true,
    cardSecurityTooltip: false,
    changed: false,
    newCard: false,
    existingCard: false,
    existingCardMaskedNumber: '',
    existingCardExpiry: '',
    creditCardFormReady: false,
    providerProcessing: false,
    createCardError: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let newState = { ...prevState };
    if (
      !prevState.changed
      && nextProps.backendErrors !== prevState.backendErrors
    ) {
      newState = {
        ...newState,
        backendErrors: nextProps.backendErrors,
      };
    }
    if (!prevState.changed && prevState.newCard !== nextProps.existingCard) {
      newState = {
        ...newState,
        newCard: !nextProps.existingCard,
        existingCard: nextProps.existingCard,
        existingCardMaskedNumber: nextProps.existingCardMaskedNumber,
        existingCardExpiry: nextProps.existingCardExpiry,
      };
    }
    return newState;
  }

  validateCard = () => !(
    this.state.errors.cardName
    || this.state.errors.cardNumber
    || this.state.errors.cardExpiry
    || this.state.errors.cardCvv
  );

  // handleChange = (e) => {
  //   e.persist();
  //   this.setState({ backendErrors: {}, changed: true });
  //   this.setState((previousState) => changeState(previousState, e.target));
  // };

  handleChange = (fieldName, valid) => {
    this.setState((previousState) => {
      const newState = {
        backendErrors: undefined,
        changed: true,
        createCardError: false,
        [fieldName]: valid,
      };
      return newState;
    });
  };

  // handleCardNumberChange = (e) => {
  //   this.setState({
  //     backendErrors: {},
  //     changed: true,
  //     cardNumber: e.target.value,
  //   });
  // };

  // handleCardExpiryChange = (e) => {
  //   this.setState({
  //     backendErrors: {},
  //     changed: true,
  //     cardExpiry: e.target.value,
  //   });
  // };

  // handleCardCVCChange = (e) => {
  //   this.setState({
  //     backendErrors: {},
  //     changed: true,
  //     cardCvv: e.target.value,
  //   });
  // };

  handleCardSecurityTooltipToggle = () => {
    this.setState((previousState) => ({
      cardSecurityTooltip: !previousState.cardSecurityTooltip,
    }));
  };

  handleAllowSaveCard = () => {
    this.setState((previousState) => ({
      saveCardAllowed: !previousState.saveCardAllowed,
    }));
  };

  handleAcceptTerms = () => {
    this.setState((previousState) => ({
      accepted: !previousState.accepted,
    }));
  };

  handleSubmit = (e, asmPayload) => {
    e.preventDefault();
    // console.log(e)
    // console.log(this)
    if (this.state.existingCard) {
      // console.log('submitting existing')
      this.setState({ changed: false, backendErrors: {} }, () => {
        this.props.handleSubmit({
          newCard: false
        });

      })
    }
    if (this.state.newCard) {
      // console.log('submitting new')
      this.setState({
        providerProcessing: true,
      });
      const cardAccountId = asmPayload?.card_accounts?.id;
      if (!_.isEmpty(asmPayload)) {
        if (this.validateCard() &&
          this.props.creditCardToken &&
          !_.isEmpty(asmPayload?.card_accounts?.id)) {
          this.setState({
            changed: false,
            backendErrors: {},
          }, () => {
            this.props.handleSubmit({
              newCard: true,
              saveCardAllowed: this.state.saveCardAllowed,
              cardAccountId: cardAccountId,
            }, () => this.setState({
              providerProcessing: false,
            }));
          });

        }
      }
    }
  };

  handleNewCardSubmitError = (e, asmPayload) => {
    e.preventDefault();
    if (this.state.newCard) {
      if (!_.isEmpty(asmPayload?.errors)) {
        this.setState({
          providerProcessing: false,
          createCardError: true,
        });
        this.props.createCreditCardToken({
          secureReference: this.props.secureReference,
          user: { id: this.props.creditCardUserId },
        });
      }
    }
  }

  handleCardAddingStatus = () => {
    this.setState({
      providerProcessing: true,
    });
  }

  handleSelectNewCard = () => {
    this.props.createCreditCardToken({
        secureReference: this.props.secureReference,
        user: { id: this.props.creditCardUserId },
      });
    this.setState((previousState) => ({
      newCard: true,
      backendErrors: {},
      creditCardFormReady: false,
      existingCard: false,
      changed: true,
    }));
  };

  handleSelectExistingCard = () => {
    this.setState((previousState) => ({
      existingCard: true,
      backendErrors: {},
      newCard: false,
      creditCardFormReady: false,
      changed: true,
    }));
  };

  handleFormIsReady = (isReady) => {
    this.setState({ creditCardFormReady: isReady });
  };

  isValid = () => {
    if (this.state.newCard) {
      return (
        this.state.cardName
        && this.state.cardNumber
        && this.state.cardExpiry
        && this.state.cardCvv
        && this.state.accepted
      );
    }
    if (this.state.existingCard) {
      return this.state.accepted;
    }
    return false;
  };

  renderBackendErrors = (): React.ReactNode => {
    if (
      this.state.backendErrors !== undefined
      && this.state.backendErrors.message !== undefined
    ) {
      return (
        <span className="text-left backend-errors">
          {this.state.backendErrors.message}
        </span>
      );
    }
    return null;
  };

  renderProcessingBackendErrors = (): React.ReactNode => {
    if (
      this.props.processingBackendErrors !== undefined
      && this.props.processingBackendErrors.message !== undefined
    ) {
      return (
        <span className="text-left backend-warning with-margin-top">
          Processing is taking longer than usual, below will refresh once we have received a response from our payment gateway.
        </span>
      );
    }
    return null;
  };

  renderPaymentMethodSelection = (): React.ReactNode => (
    <div>
      <form id="new-asm-card" onSubmit={this.handleSubmit}>
        <div className={classnames("row", { "d-none": !this.props.cardIsLoading })}>
          <div className="col">
            <Loader isActive className="relative" color="grey" />
          </div>
        </div>
        <div className={classnames({ "d-none": this.props.cardIsLoading })}>
          {this.props.existingCard && (
            <div className="row">
              <div className="col d-flex align-items-start">
                <div className="d-flex text-left h-100 w-100 with-padding-10">
                  <div className="d-flex justify-content-center align-items-center float-left">
                    <Checkbox
                      onClick={this.handleSelectExistingCard}
                      checked={this.state.existingCard}
                      radio
                    />
                  </div>
                  <div className="d-block float-left w-auto">
                    <Label
                      onClick={this.handleSelectExistingCard}
                      className="checkbox-label"
                    >
                      Existing card ending with
                      {' '}
                      {friendlyCreditCardMask(this.state.existingCardMaskedNumber)}
                      {' '}
                      (expires
                      {' '}
                      {this.state.existingCardExpiry}
                      )
                    </Label>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col d-flex align-items-start">
              <div className="d-flex text-left h-100 w-100">
                <div className="d-block float-left">
                  <Checkbox
                    onClick={this.handleSelectNewCard}
                    checked={this.state.newCard}
                    radio
                  />
                </div>
                <div className="d-block float-left w-auto">
                  <div className="w-100 d-block">
                    <div className="d-inline-block margin-right-10">
                      <Label
                        onClick={this.handleSelectNewCard}
                        className="checkbox-label"
                      >
                        New credit / debit card
                      </Label>
                    </div>
                    <div className="d-inline-block">
                      <Isvg
                        className="checkout-payment-option-icon"
                        src={MastercardIcon}
                      />
                      <Isvg
                        className="checkout-payment-option-icon"
                        src={VisaIcon}
                      />
                      <HelpTooltip id="card-help-tooltip" placement="right">
                        Teammo accepts Visa and Mastercard credit and debit cards.
                        We do not accept AMEX.
                      </HelpTooltip>
                    </div>
                  </div>

                  <Collapse isOpen={this.state.newCard}>
                    {this.state.newCard && this.renderNewCard()}
                  </Collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!this.props.isLoading && this.renderSubmitButton()}
      </form>
    </div>
  );

  // renderExistingCard = (): React.ReactNode => <div>Existing Card</div>;

  renderNewCard = (): React.ReactNode => (
    <div>
      <div className="row with-margin-top-10">
        <div className="col">
          <div className="border border-round with-padding">
            {/* <div className="row">
                  <div className="col col-12">
                    <InputGroupBlock
                      name="cardName"
                      labelText="Name on card"
                      placeholder="Name on card"
                      tabIndex="1"
                      autoComplete="false"
                      errors={this.props.errors}
                      value={this.state.cardName}
                      onChange={this.handleChange}
                      inputGroupClassName="no-margin-bottom"
                    />
                  </div>
                </div> */}
            <div className={classnames("row", { "d-none": this.state.creditCardFormReady })}>
              <div className="col">
                <Loader skeleton count={3} isActive color="grey" />
              </div>
            </div>
            <div className={classnames("row", { "d-none": !this.state.creditCardFormReady })}>
              <div className="col col-12">

                {!_.isEmpty(this.props.creditCardToken) && <CreditCardInputNew
                  isLoading={this.props.isLoading}
                  newCard={this.state.newCard}
                  handleChange={this.handleChange}
                  handleSubmit={this.handleSubmit}
                  handleSubmitError={this.handleNewCardSubmitError}
                  handleFormIsReady={this.handleFormIsReady}
                  handleCardAddingStatus={this.handleCardAddingStatus}
                  // handleIsSubmitting={this.handleIsSubmitting}
                  // handleIsNotSubmitting={this.handleIsNotSubmitting}
                  creditCardToken={this.props.creditCardToken}
                  creditCardUserId={this.props.creditCardUserId}
                />}
              </div>
            </div>
            <div className="row with-margin-top-10 margin-bottom-5">
              <div className="col d-flex align-items-start">
                <div className="d-flex justify-content-center align-items-start h-100 w-auto">
                  <Checkbox checked={this.state.saveCardAllowed} onClick={this.handleAllowSaveCard} />
                  <Label onClick={this.handleAllowSaveCard} className="checkbox-label">
                    Save card details for future payments
                  </Label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  renderSubmitButton = (): React.ReactNode => {
    return (<div>
      <div className="row">
        <div className="col">
          <div className="divider full with-margin-top" />
        </div>
      </div>
      <div className="row">
        <div className="col text-left caption-text text-grey">
          By paying, you are agreeing to the Teammo
          {' '}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.teammo.com.au/policies#terms-conditions"
          >
            Terms &amp; Conditions
          </a>
          . To see how we manage your personal information, see our
          {' '}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.teammo.com.au/policies#privacy-policy"
          >
            Privacy Policy
          </a>
          .
        </div>
      </div>
      <div className="row with-margin-top">
        <div className="col text-right">
          {this.state.existingCard && (<Button
            className="btn-success"
            type="button"
            onClick={this.handleSubmit}
            disabled={this.props.isLoading || !this.isValid()}
            isLoading={this.props.isLoading}
          >
            {`Pay ${parseAmount(this.props.totalAmount)}`}
          </Button>)}
          {this.state.newCard && (<Button
            className="btn-success"
            type="submit"
            disabled={this.props.isLoading || !this.isValid() || this.state.providerProcessing}
            isLoading={this.props.isLoading || this.state.providerProcessing}
            hasFailed={this.state.createCardError}
          >
            {`Pay ${parseAmount(this.props.totalAmount)}`}
          </Button>)}
        </div>
      </div>
    </div>)
  }

  render(): React.ReactNode {
    // renderAssemblyJs();
    // console.log(this.props.isLoading)
    return (
      <div>
        <div>
          {!_.isEmpty(this.props.matchCardData) && this.props.bulkMatchPaymentId === undefined && (
            <div className="row">
              <div className="col">
                <PaymentCardMin {...this.props.matchCardData} truncated />
              </div>
            </div>
          )}
          {this.props.paymentCategory === 'event-variable' && (
            <CartSummary
              lineItems={this.props.lineItems}
              totalAmount={this.props.totalAmount}
            />
          )}
          {(this.props.isLoading || this.props.currentPurchaseStatus === 'processing-async') && this.renderProcessingBackendErrors()}
          {(this.props.isLoading || this.props.currentPurchaseStatus === 'processing-async') && <PaymentProcessingLoader />}
          <div className={classnames("row with-margin-top-extra", { "d-none": (this.props.isLoading || this.props.currentPurchaseStatus === 'processing-async') })}>
            <div className="col">
              <SectionGroup
                title={`Pay ${parseAmount(this.props.totalAmount)} for ${this.props.description
                  }`}
              >
                <div className="row">
                  <div className="col col-12 form-description text-black">
                    {this.renderBackendErrors()}
                  </div>
                </div>
                {this.renderPaymentMethodSelection()}
              </SectionGroup>
            </div>
          </div>
        </div>
      </div >
    );
  }
}
